import { ApiService } from "./../../services/api.service";
import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { CompanyDepth } from "src/app/models/company-depth";
import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import * as signalR from "@microsoft/signalr";
import { UrlConstants } from "src/app/models/urlConstants";

@Component({
  selector: "app-market-depth-bids",
  templateUrl: "./market-depth-bids.component.html",
  styleUrls: ["./market-depth-bids.component.scss"],
})
export class MarketDepthBidsComponent implements OnInit {
  @Input() symbolCode: string;
  @Input() reuters: string;
  @Input() companyName: string;
  isDepthLoading: boolean;
  companyDepth: CompanyDepth;
  isOrder: boolean = false;

  private depthConnection: HubConnection;

  constructor(private _service: ApiService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.reuters) {
      this.symbolCode = changes?.symbolCode?.currentValue;
      this.reuters = changes.reuters?.currentValue;
    }
    if (this.symbolCode) {
      this.companyDepth = null;
      this.isDepthLoading = true;
      if (this.isOrder) this.fetchDepthByOrder();
      else if (!this.isOrder) this.fetchDepthByPrice();
    }

    if (!this.isOrder && this.symbolCode) {
      if (this.depthConnection) this.depthConnection.stop();
      this.connectSignalR();
    }
  }

  connectSignalR() {
    this.depthConnection = new HubConnectionBuilder()
      .withUrl(UrlConstants.newSignalR + "/bidsAsksHub", {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
      })
      .build();

    this.depthConnection
      .start()
      .then((res) =>
        this.depthConnection
          .invoke("JoinGroup", this.symbolCode)
          .then((value) => {
            this.depthConnection.on("sendBidsAsksForSymbol", (depthUpdate) => {
              let update = depthUpdate[0]["MarketDepth"] as CompanyDepth;
              this.companyDepth.asksPerPrice = update.asksPerPrice;
              this.companyDepth.bidsPerPrice = update.bidsPerPrice;
              this.companyDepth.totalsBidsAndAsks = update.totalsBidsAndAsks;
            });
          })
      )
      .catch();
  }

  ngOnDestroy(): void {
    if (this.depthConnection) this.depthConnection.stop();
  }

  toggleOrderView(value) {
    if (this.symbolCode) this.isDepthLoading = true;
    this.isOrder = value;
    if (value) this.fetchDepthByOrder();
    else this.fetchDepthByPrice();
  }

  fetchDepthByOrder() {
    this._service.fetchDepthByOrder(this.symbolCode).subscribe((res) => {
      this.isDepthLoading = false;
      this.companyDepth = res as CompanyDepth;
    });
  }
  fetchDepthByPrice() {
    this._service.fetchDepthByPrice(this.symbolCode,10).subscribe((res) => {
      this.isDepthLoading = false;
      this.companyDepth = res as CompanyDepth;
    });
  }
  ngOnInit() {}
}
